import BreadcrumbView from '../../common/breadcrumb/breadcrumb.html';
import ForbiddenView from './forbidden.html';


angular.module("forbidden", [])

   .config(['$stateProvider', function ($stateProvider) {
       $stateProvider
           .state('forbidden', {
               url: "/forbidden",
               abstract: true,
               controller: "BreadcrumbCtrl",
               template: BreadcrumbView,
           })
           .state('forbidden.list', {
               url: "/list",
               controller: "ForbiddenCtrl",
               template: ForbiddenView
           })
       ;
   }])

    .controller('ForbiddenCtrl', ['$scope', function ($scope) {
       
    }])
;